import {
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  Resize,
  PageSettingsModel,
  Toolbar,
  SelectionSettingsModel,
  Group,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { all_information, loadingShow } from '../../../App';
import { ThemeContext } from '../../../context/theme.context';
import { getShiftWorkbenchTemplate } from '../../../services/ShiftWorkbench/ShitWorkbenchTemplateService';
import Message from '../../../utils/Message/Message';
import './styleMovements.css';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getShiftWorkbenchSettings } from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import { getAssignments } from '../../../services/assignments/assignmentService';
import {
  AddShiftWorkbenchSubStuff,
  DeleteShiftWorkbenchSubStuff,
  EditShiftWorkbenchSubStuff,
  getShiftWorkbenchSubStuff,
} from '../../../services/ShiftWorkbench/ShiftWorkbenchSubStuff';
import { getTeamAssigments } from '../../../services/tradeperson/team';
interface IProps {
  workbench_data: any;
}
interface IState {
  data: Array<string>;
  AssetData: Array<any>;
  TeamAssignmentData: Array<any>;
  hideDialogTemplate: boolean;
  hideDialogDelete: boolean;
  TemplateData: Array<any>;
  renderFunction: boolean;
  truckFactorData: any;
  targetData: any;
  sourceData: any;
  mareaData: any;
  mTypeData: any;
  hideDialogIsAdded: boolean;
}
class ProductionMovements extends Component<IProps, IState> {
  public toolbarOptions = [
    'Add',
    'Edit',
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Apply Default Template',
      tooltipText: 'Apply Default Template',
      prefixIcon: 'e-save',
      id: 'apply-template',
    },
    {
      text: 'Template',
      tooltipText: 'Template',
      prefixIcon: 'e-add',
      id: 'add-template',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  private fieldOperator: object = {
    text: 'alias_name',
    value: 'assignment_id',
  };
  private fieldAssetType: object = {
    text: 'asset_code',
    value: 'id',
  };
  private fieldTemplate: object = {
    text: 'name',
    value: 'id',
  };
  private buttons: ButtonPropsModel[];
  private buttonsForDelete: ButtonPropsModel[];
  private buttonsIsAddedMovements: ButtonPropsModel[];
  public validationRule: Object = { required: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private created_date = new Date();
  private workbench_id = -1;
  private team_id = -1;
  private TemplateData: any = [];
  private is_override: any = false;
  private numericParams = { params: { decimals: 2 } };
  private dropDownListObjectOperator: DropDownListComponent;
  private dropDownListObjectMType: DropDownListComponent;
  private dropDownListObjectMarea: DropDownListComponent;
  private dropDownListObjectTrucFactor: DropDownListComponent;
  private dropDownListObjectSourceL: DropDownListComponent;
  private dropDownListObjectTargetL: DropDownListComponent;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: false,
    newRowPosition: 'Top',
  };
  private settings: SelectionSettingsModel = {
    checkboxMode: 'ResetOnRowClick',
    checkboxOnly: false,
  };
  private gridWorkbenchMovementsObj: any;
  private unit: string = 'pmov';
  constructor(props: IProps) {
    super(props);
    this.state = {
      data: [],
      AssetData: [],
      TeamAssignmentData: [],
      TemplateData: [],
      hideDialogTemplate: false,
      hideDialogDelete: false,
      renderFunction: false,
      truckFactorData: [],
      targetData: [],
      sourceData: [],
      mareaData: [],
      mTypeData: [],
      hideDialogIsAdded: false,
    };
    this.buttons = [
      {
        click: () => {
          // this.SavePointTemplate();
        },
        buttonModel: {
          content: 'Add',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogTemplate: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsForDelete = [
      {
        click: () => {
          this.savePointDeleteMovements();
        },
        buttonModel: {
          content: 'OK',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsIsAddedMovements = [
      {
        click: () => {
          this.is_override = false;
          this.SavePointTemplateMovements();
        },
        buttonModel: {
          content: 'Append',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.is_override = true;
          this.SavePointTemplateMovements();
        },
        buttonModel: {
          content: 'Override',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogIsAdded: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.dropDownListObjectMType = new DropDownListComponent(props);
    this.dropDownListObjectMarea = new DropDownListComponent(props);
    this.dropDownListObjectOperator = new DropDownListComponent(props);
    this.dropDownListObjectSourceL = new DropDownListComponent(props);
    this.dropDownListObjectTargetL = new DropDownListComponent(props);
    this.dropDownListObjectTrucFactor = new DropDownListComponent(props);
  }
  async componentDidMount() {
    this.getMType();
    this.getMarea();
    this.getSource();
    this.getTarget();
    this.getTruckFactor();
    loadingShow(true);
    this.workbench_id = parseInt(this.props.workbench_data.id);
    this.created_date = new Date(this.props.workbench_data.date);
    this.team_id = parseInt(this.props.workbench_data.team_id);
    this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
    this.getAllAssignment();
    await this.getAssetType();
    await this.getWorkbenchTemplateemplate('Production Movements');
    loadingShow(false);
  }
  getTarget() {
    getShiftWorkbenchSettings('targetlocation')
      .then((el) => {
        this.setState({ targetData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getMarea() {
    getShiftWorkbenchSettings('marea')
      .then((el) => {
        this.setState({ mareaData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getMType() {
    getShiftWorkbenchSettings('movementstype')
      .then((el) => {
        this.setState({ mTypeData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getSource() {
    getShiftWorkbenchSettings('sourcelocation')
      .then((el) => {
        this.setState({ sourceData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getTruckFactor() {
    getShiftWorkbenchSettings('trackfactor')
      .then((el) => {
        this.setState({ truckFactorData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBeginProductionEquipmentSummary(args: any) {
    if (args.action === 'add') {
      this.savePointAddMovements(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditMovements(args.data);
    }
  }
  async SavePointTemplateMovements() {
    let data = this.TemplateData;
    let obj = data.details.map((item: any) => {
      return {
        app: 'app',
        organization_id: all_information.company_id?.toString(),
        workbench_id: this.workbench_id,
        date: this.created_date,
        template_id: data.id,
        user_id: all_information.user_id,
        comments: '',
        truck_name: '',
        truck_id: -1,
        site: '',
        loads: '',
        shift: '',
        bcm_estimate: '',
        unit: '${this.unit}',
        is_override: this.is_override,
        s_location_id: item.s_location_id,
        s_location: item.s_location,
        t_location_id: item.t_location_id,
        t_location: item.t_location,
        m_type: item.m_type,
        m_type_id: item.m_type_id,
        m_area: item.m_area,
        m_area_id: item.m_area_id,
        excavator: item.excavator,
        truck: item.truck,
        operator_name: item.assignment_code,
        operator_id: item.assignment_id,
      };
    });
    loadingShow(true);
    await AddShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
        this.setState({ hideDialogIsAdded: false });
        this.context.setChangeTabForTemplateWB(true, 1);
        this.context.setDataChangeForTemplateWBData(true);
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  getTeamAssignment(teamID: number) {
    getTeamAssigments(teamID).then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  getAllAssignment() {
    getAssignments().then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  async getAssetType() {
    await getShiftWorkbenchSettings('assettype').then((res) => {
      this.setState({ AssetData: res.data });
    });
  }
  getWorkbenchTemplateemplate(whereModule: string) {
    getShiftWorkbenchTemplate().then((result) => {
      let filterData: any = result.data;
      if (whereModule !== '') {
        filterData = result.data.filter((x: any) => x.tab_name === whereModule);
      }
      this.setState({ TemplateData: filterData });
    });
  }
  getWorkbenchMovementsFields(query: string) {
    getShiftWorkbenchSubStuff(query).then((res) => {
      this.setState({ data: res.data });
    });
  }
  async savePointAddMovements(obje: any) {
    var date = this.created_date;
    var truck_factor = [];
    var bcm_estimate = 0;
    if (obje.truck) {
      truck_factor = this.state.truckFactorData.filter((el: any) => {
        return el.asset_no === obje.truck;
      });
      if (truck_factor.length > 0) {
        bcm_estimate =
          Number(truck_factor[0]?.truck_factor) *
          Number(obje.loads === undefined ? 0 : obje.loads);
      }
    }
    const obj = {
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.workbench_id,
      comments: obje.comments,
      truck_name: '',
      truck_id: truck_factor[0]?.truck_factor,
      site: obje.site,
      loads: obje.loads,
      shift: obje.shift,
      bcm_estimate: bcm_estimate,
      date: date,
      user_id: all_information.user_id,
      unit: this.unit,
      s_location_id: this.dropDownListObjectSourceL.value,
      s_location: this.dropDownListObjectSourceL.text,
      t_location_id: this.dropDownListObjectTargetL.value,
      t_location: this.dropDownListObjectTargetL.text,
      m_type: this.dropDownListObjectMType.text,
      m_type_id: this.dropDownListObjectMType.value,
      m_area: this.dropDownListObjectMarea.text,
      m_area_id: this.dropDownListObjectMarea.value,
      excavator: obje.excavator,
      truck: obje.truck,
      operator_name: this.dropDownListObjectOperator.text,
      operator_id: this.dropDownListObjectOperator.value,
    };
    AddShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  async savePointEditMovements(obje: any) {
    var truck_factor = [];
    var bcm_estimate = 0;
    if (obje.truck) {
      truck_factor = this.state.truckFactorData.filter((el: any) => {
        return el.asset_no === obje.truck;
      });
      if (truck_factor.length > 0) {
        bcm_estimate =
          Number(truck_factor[0]?.truck_factor) *
          Number(obje.loads === undefined ? 0 : obje.loads);
      }
    }
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.workbench_id,
      comments: obje.comments,
      truck_name: '',
      truck_id: truck_factor[0]?.truck_factor,
      site: obje.site,
      loads: obje.loads,
      shift: obje.shift,
      bcm_estimate: bcm_estimate,
      user_id: all_information.user_id,
      unit: this.unit,
      s_location_id: this.dropDownListObjectSourceL.value,
      s_location: this.dropDownListObjectSourceL.text,
      t_location_id: this.dropDownListObjectTargetL.value,
      t_location: this.dropDownListObjectTargetL.text,
      m_type: this.dropDownListObjectMType.text,
      m_type_id: this.dropDownListObjectMType.value,
      m_area: this.dropDownListObjectMarea.text,
      m_area_id: this.dropDownListObjectMarea.value,
      excavator: obje.excavator,
      truck: obje.truck,
      operator_name: this.dropDownListObjectOperator.text,
      operator_id: this.dropDownListObjectOperator.value,
      date: obje.date,
      id: obje.id,
    });

    EditShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }

  async savePointDeleteMovements() {
    var data = (
      this.gridWorkbenchMovementsObj as GridComponent
    ).getSelectedRecords() as any;
    loadingShow(true);
    DeleteShiftWorkbenchSubStuff(data)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
        this.setState({ hideDialogDelete: false });
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private async toolbarClick(args: any) {
    if (args.item.text === 'Add') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchMovementsObj.refresh();
      }
    }
    if (args.item.id === 'delete') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchMovementsObj.refresh();
      }
      if (
        (this.gridWorkbenchMovementsObj as GridComponent).getSelectedRecords()
          .length > 0
      ) {
        this.setState({ hideDialogDelete: true });
      } else {
        Message.error('Please select a record!');
      }
    }
    if (args.item.id === 'add-template') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchMovementsObj.refresh();
      } else {
        this.context.setChangeCurrentTabWorkbenchBottom(
          true,
          this.workbench_id
        );
        this.context.setDataChangeWorkbenchBottomData(
          true,
          this.created_date +
            ',' +
            this.workbench_id +
            ',' +
            'Production Movements'
        );
      }
    }
    if (args.item.id === 'refresh') {
      this.getWorkbenchMovementsFields(`${this.unit}$${this.workbench_id}`);
    }
    if (args.item.id === 'apply-template') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        return false;
      }

      let findTemplate = this.state.TemplateData.find(
        (x: any) => x.isDefault === true
      );

      if (findTemplate !== undefined) {
        this.TemplateData = findTemplate;
        await this.getWorkbenchMovementsFields(
          `${this.unit}$${this.workbench_id}`
        );
        let findData = this.state.data.find(
          (x: any) => x.template_id === findTemplate.id
        );
        if (findData !== undefined) this.setState({ hideDialogIsAdded: true });
        else this.SavePointTemplateMovements();
      } else {
        Message.error('Default template not found!');
      }
    }
  }

  private OperatorTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Operator'
        text={args.operator_name}
        value={args.operator_id}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope: DropDownListComponent) =>
          (this.dropDownListObjectOperator = scope)
        }
        onChange={(e: any) => {
          //(e);
        }}
        fields={this.fieldOperator}
      />
    );
  }
  private MareaTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Mining Area'
        text={args.m_area}
        value={args.m_area_id}
        ref={(scope: DropDownListComponent) =>
          (this.dropDownListObjectMarea = scope)
        }
        dataSource={this.state.mareaData}
        fields={{ text: 'area_code', value: 'id' }}
      />
    );
  }
  private MTypeTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Movements Type'
        text={args.m_type}
        ref={(scope: DropDownListComponent) =>
          (this.dropDownListObjectMType = scope)
        }
        value={args.m_type_id}
        dataSource={this.state.mTypeData}
        fields={{ text: 'm_type_code', value: 'id' }}
      />
    );
  }
  private TruckFactorTemplateEditing(args: any) {
    return <TextBoxComponent placeholder='Track Factor' enabled={false} />;
  }
  private MovementsTemplateEditing(args: any) {
    return <TextBoxComponent placeholder='' enabled={false} />;
  }
  private TargetTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Target Location'
        text={args.t_location}
        value={args.t_location_id}
        ref={(scope: DropDownListComponent) =>
          (this.dropDownListObjectTargetL = scope)
        }
        dataSource={this.state.targetData}
        fields={{ text: 't_location_code', value: 'id' }}
      />
    );
  }
  private SourceTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Source Location'
        text={args.s_location}
        value={args.s_location_id}
        ref={(scope: DropDownListComponent) =>
          (this.dropDownListObjectSourceL = scope)
        }
        dataSource={this.state.sourceData}
        fields={{ text: 's_location_code', value: 'id' }}
      />
    );
  }
  private onChangeTemplate(args: any) {
    let template_id = args.value;
    let findTemplate = this.state.TemplateData.find(
      (x: any) => x.id === template_id
    );
    if (findTemplate !== undefined) this.TemplateData = findTemplate.details;
  }
  render() {
    return (
      <div className='workbench-production-Movements'>
        <GridComponent
          id='gridWorkbenchProductionMovements'
          dataSource={this.state.data}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridWorkbenchMovementsObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          allowResizing={true}
          selectionSettings={this.settings}
          showColumnChooser
          style={{ display: 'inline-block' }}
          gridLines='Both'
          width={window.innerWidth - 115}
          height={'calc(-200px + 60vh)'}
          actionBegin={this.actionBeginProductionEquipmentSummary.bind(this)}
        >
          <ColumnsDirective>
            {/* <ColumnDirective
              field='id'
              headerText='Movements ID'
              textAlign='Left'
            /> */}
            <ColumnDirective
              field='truck'
              headerText='Truck'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='excavator'
              headerText='Excavator'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='m_area'
              headerText='Mining Area'
              editType='dropdownedit'
              editTemplate={this.MareaTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='m_type'
              headerText='Movement Type'
              editType='dropdownedit'
              editTemplate={this.MTypeTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='s_location'
              headerText='Source Location'
              editType='dropdownedit'
              editTemplate={this.SourceTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='t_location'
              headerText='Target Location'
              editType='dropdownedit'
              editTemplate={this.TargetTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='operator_name'
              headerText='Operator'
              editType='dropdownedit'
              editTemplate={this.OperatorTemplateEditing.bind(this)}
            />
            <ColumnDirective
              editType='numericedit'
              field='loads'
              headerText='Loads'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='truck_id'
              headerText='Truck Factor'
              editType='dropdownedit'
              editTemplate={this.TruckFactorTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='bcm_estimate'
              headerText='BCM Estimate'
              editTemplate={this.MovementsTemplateEditing.bind(this)}
            />
            <ColumnDirective field='comments' headerText='Comments' />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialogTemplate ? (
              <DialogComponent
                isModal={true}
                id='modalSummaryTemplate'
                animationSettings={{
                  delay: 1,
                  duration: 500,
                  effect: 'FadeZoom',
                }}
                showCloseIcon={true}
                visible={this.state.hideDialogTemplate}
                header='Equipment Summary Template'
                width={500}
                height={'auto'}
                buttons={this.buttons}
                open={() => {
                  this.setState({ hideDialogTemplate: true });
                }}
                close={() => {
                  this.setState({ hideDialogTemplate: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    <DropDownListComponent
                      placeholder='Select a template'
                      dataSource={this.state.TemplateData}
                      // ref={(scope:DropDownListComponent) => (this.dropDownListObjectTemplate = scope)}
                      onChange={this.onChangeTemplate.bind(this)}
                      fields={this.fieldTemplate}
                    />
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialogDelete ? (
              <DialogComponent
                isModal={true}
                id='modalSummaryDelete'
                animationSettings={{
                  delay: 1,
                  duration: 500,
                  effect: 'FadeZoom',
                }}
                showCloseIcon={true}
                visible={this.state.hideDialogDelete}
                header='Confirmation'
                width={200}
                height={'auto'}
                buttons={this.buttonsForDelete}
                open={() => {
                  this.setState({ hideDialogDelete: true });
                }}
                close={() => {
                  this.setState({ hideDialogDelete: false });
                }}
              >
                <div className='container'>
                  <div className='row'>Are you sure?</div>
                </div>
              </DialogComponent>
            ) : null}
            {this.state.hideDialogIsAdded ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogIsAddedMov'
                showCloseIcon={true}
                beforeClose={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
                animationSettings={{
                  delay: 1,
                  duration: 500,
                  effect: 'FadeZoom',
                }}
                visible={this.state.hideDialogIsAdded}
                header='Confirmation'
                width={500}
                height={'auto'}
                buttons={this.buttonsIsAddedMovements}
                open={() => {
                  this.setState({ hideDialogIsAdded: true });
                }}
                close={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>
                      This template has already been added. Would you like to
                      add it again?
                    </span>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default ProductionMovements;
